module.exports = __webpack_public_path__ + "img/card.be79fdf9.webp";